/**
 * Challenge votes – one vote per user per submission. Doc id: submissionId_userId.
 */
import { doc, getDoc, setDoc, deleteDoc, getDocs, query, where, collection } from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'challengeVotes';

function docId(submissionId, userId) {
  return `${submissionId}_${userId}`;
}

export function challengeVoteRepository({ getFirestore = () => db } = {}) {
  const firestore = getFirestore();
  const coll = () => collection(firestore, COLLECTION);

  return {
    async add(submissionId, userId) {
      const id = docId(submissionId, userId);
      const ref = doc(firestore, COLLECTION, id);
      const snap = await getDoc(ref);
      if (snap.exists()) return { added: false };
      await setDoc(ref, { submissionId, userId, vote: true, createdAt: new Date() });
      return { added: true };
    },

    async remove(submissionId, userId) {
      const id = docId(submissionId, userId);
      const ref = doc(firestore, COLLECTION, id);
      await deleteDoc(ref);
    },

    async hasUserVoted(submissionId, userId) {
      const ref = doc(firestore, COLLECTION, docId(submissionId, userId));
      const snap = await getDoc(ref);
      return snap.exists();
    },

    async getVotedSubmissionIds(userId, submissionIds) {
      if (!userId || submissionIds.length === 0) return new Set();
      const q = query(coll(), where('userId', '==', userId));
      const snap = await getDocs(q);
      const set = new Set();
      snap.forEach((d) => {
        const sid = d.data().submissionId;
        if (submissionIds.includes(sid)) set.add(sid);
      });
      return set;
    },
  };
}

export const challengeVoteRepo = challengeVoteRepository();
